<template lang="html">
    <div :is="'reservation-payment'" :direction="0" ></div>
</template>

<script>
import ReservationPayment from './ReservationPayment'
export default {
    components:{
        ReservationPayment
    }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// ReservationPayIn.vue?1f177dfc